// extracted by mini-css-extract-plugin
module.exports = {"actionLink":"landing-module_actionLink_OU7tT"};